type DateInput = string | number | Date;

export const formatDate = (dateString: DateInput, isSeparator: boolean = false, includeTime: boolean = false) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  const dateOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: isSeparator ? 'short' : 'long',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('en-GB', dateOptions);

  if (includeTime) {
    const timeFormatted = date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${formattedDate} at ${timeFormatted}`;
  }

  if (isSeparator) {
    const [day, month, year] = formattedDate.split(' ');
    return `${day} ${month.replace(',', '')}, ${year}`;
  }

  return formattedDate;
};

export const shortFormatDate = (timestamp: DateInput) => {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear().toString().slice(-2);
  return `Posted on ${day} ${month} '${year}`;
};

export const newsBlogFormatDate = (timestamp: DateInput, includeTime: boolean = false) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const now: Date = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

  // For relative time formats (recent dates)
  if (diff < 60) {
    return 'Just Now';
  } else if (diff < 3600) {
    const minutes = Math.floor(diff / 60);
    return `${minutes} ${minutes === 1 ? 'Minute' : 'Minutes'} Ago`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    return `${hours} ${hours === 1 ? 'Hour' : 'Hours'} Ago`;
  } else if (diff < 604800) {
    const days = Math.floor(diff / 86400);
    return `${days} ${days === 1 ? 'Day' : 'Days'} Ago`;
  }

  // For absolute date format (older dates)
  const dateFormatted = date.toDateString();

  // Add time if requested
  if (includeTime) {
    const timeFormatted = date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${dateFormatted} at ${timeFormatted}`;
  }

  return dateFormatted;
};

export const getSortedNewsData = (newsData: any[]) => {
  return newsData?.toSorted((a, b) => {
    const dateA = new Date(a?.updatedAt);
    const dateB = new Date(b?.updatedAt);
    return dateB.getTime() - dateA.getTime();
  });
};
